import React, { useRef } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { useFriendshipModel } from "../friendshipModel";
import { YhForm } from "@/components/YhFormBox";
import { IYhForm, IYhFormRef, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { IFriendshipDetail } from "../friendshipTypes";
import { message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { divide } from "lodash";
import useGlobalModel from "@/model/globalModel";
export function DetailDrawer() {
    const {
        visibleDrawer: { visible, mode },
        selectedRow,
        setVisibleDrawer,
        setIVisibleDrawer,
        editDetail,
        insertDetail
    } = useFriendshipModel()
    const { user } = useGlobalModel();
    const formRef = useRef<IYhFormRef>();
    const onCancel = () => {
        setIVisibleDrawer()
    }
    const onSubmit = () => {
        // setIVisibleDrawer()
        formRef.current?.validateFields().then((val: any) => {
            mode === "edit" ? editDetail(val) : insertDetail(val)
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const formConfig: IYhForm<IFriendshipDetail> = {
        formRef,
        labelCol: { span: 6 },
        // formValues: {},
        formValues: mode === "edit" || mode === "look" ? selectedRow[0] : { createUser: user.userName },
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "网站名称",
                fieldName: "siteName",
                disable: mode === "look",
                rules: [{ required: true, message: "请输入网站名称" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "链接地址",
                fieldName: "url",
                disable: mode === "look",
                rules: [{ required: true, message: "请输入链接地址" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "链接页面",
                fieldName: "linkPage",
                disable: mode === "look",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                disable: mode === "look",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 24,
                disable: true
            },
        ]
    }
    return (
        <YHDrawer
            {...{
                title: `友情链接${mode === "add" ? '新增' : mode === "edit" ? '编辑' : '查看'}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                showFooter: mode !== "look"
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}